import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".panel-text-block");
  if (!blocks.length) return;

  // Snapshot del breakpoint y de la preferencia de motion en el load. La
  // animación es one-shot disparada por scroll: una vez ejecutada no hace
  // falta re-evaluar el viewport.
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  blocks.forEach((block) => {
    const sticker = block.querySelector(".panel-text-block__sticker");
    if (!sticker) return;

    // Estado "asentado" según breakpoint:
    // - Desktop: position:absolute con top:50% → centrado vertical vía
    //   yPercent:-50 + rotación 11.41deg (mismo valor que el CSS).
    // - Mobile: flex item sin transform, rotación 0.
    const finalRotation = isDesktop ? 11.41 : 0;
    const finalYPercent = isDesktop ? -50 : 0;

    // Si el usuario tiene reduced motion, saltamos al estado final y no
    // creamos timeline ni ScrollTrigger.
    if (reduceMotion) {
      gsap.set(sticker, {
        autoAlpha: 1,
        scale: 1,
        rotation: finalRotation,
        yPercent: finalYPercent,
      });
      return;
    }

    // Estado inicial pre-caída: arriba del sitio, más grande y más rotado.
    gsap.set(sticker, {
      autoAlpha: 0,
      scale: 1.7,
      rotation: 35,
      yPercent: finalYPercent - 60,
      transformOrigin: "50% 50%",
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 80%",
        once: true,
      },
    });

    tl
      // 1. Caída — la pegatina llega volando hacia el sitio.
      .to(sticker, {
        autoAlpha: 1,
        scale: 1.05,
        rotation: finalRotation - 4,
        yPercent: finalYPercent,
        duration: 0.45,
        ease: "power2.in",
      })
      // 2. Impacto — un overshoot mínimo, como el "click" del pegado.
      .to(sticker, {
        scale: 0.94,
        duration: 0.12,
        ease: "power2.out",
      })
      // 3. Wobble + settle — pequeño rebote elástico hasta el reposo, y
      //    clearProps para devolver el control al CSS al terminar.
      .to(sticker, {
        scale: 1,
        rotation: finalRotation,
        duration: 0.5,
        ease: "elastic.out(1, 0.3)",
        clearProps: "all",
      });
  });
});
